module.exports = __webpack_public_path__ + "img/icon_manejo_formularios.6b7a46ab.svg";